import { 
  red, 
  pink, 
  purple, 
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  yellow,
  orange,
  deepOrange
} from "@mui/material/colors";


function GetAvatarColour(name) {
  const letter = name.toLowerCase().charAt(0);
  return avatarColourMap[letter][500];
}

export default GetAvatarColour;





const avatarColourMap = {
  "a": red,
  "b": purple,
  "c": indigo,
  "d": lightBlue,
  "e": teal,
  "f": yellow,
  "g": deepOrange,
  "h": pink,
  "i": deepPurple,
  "j": blue,
  "k": cyan,
  "l": green,
  "m": orange,
  "n": red,
  "o": purple,
  "p": indigo,
  "q": lightBlue,
  "r": teal,
  "s": yellow,
  "t": deepOrange,
  "u": pink,
  "v": deepPurple,
  "w": blue,
  "x": cyan,
  "y": green,
  "z": orange,
};